<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Editar
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.codigo" :error="form.errors.codigo" class="pr-6 pb-8 w-full lg:w-1/4" label="Código" />
          <text-input v-model="form.arete" :error="form.errors.arete" class="pr-6 pb-8 w-full lg:w-1/4" label="Arete" />
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-2/4" label="Nombre" required />

          <select-input v-model="form.especie_id" :error="form.errors.especie_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Especie" required>
            <option :value="null" disabled>Seleccione una especie</option>
            <option v-for="e in especies" :key="e.id" :value="e.id">
              {{ e.nombre }}
            </option>
          </select-input>

          <select-input v-model="form.raza_id" :error="form.errors.raza_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Raza">
            <option :value="null">Sin raza</option>
            <option v-for="r in razas" :key="r.id" :value="r.id">
              {{ r.nombre }}
            </option>
          </select-input>

          <select-input v-model="form.sexo" :error="form.errors.sexo" class="pr-6 pb-8 w-full lg:w-1/4" label="Sexo" required>
            <option :value="null" disabled>Seleccione</option>
            <option value="macho">Macho</option>
            <option value="hembra">Hembra</option>
          </select-input>

          <text-input v-model="form.fecha_nacimiento" :error="form.errors.fecha_nacimiento" class="pr-6 pb-8 w-full lg:w-1/4" label="Fecha de Nacimiento" type="date" />
          <text-input v-model="form.peso" :error="form.errors.peso" class="pr-6 pb-8 w-full lg:w-1/4" label="Peso (kg)" type="number" />
          <text-input v-model="form.color" :error="form.errors.color" class="pr-6 pb-8 w-full lg:w-1/4" label="Color" />

          <text-input v-model="form.estado_reproductivo" :error="form.errors.estado_reproductivo" class="pr-6 pb-8 w-full lg:w-2/4" label="Estado Reproductivo" />
          <select-input v-model="form.estado" :error="form.errors.estado" class="pr-6 pb-8 w-full lg:w-2/4" label="Estado" required>
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
            <option value="Vendido">Vendido</option>
            <option value="Fallecido">Fallecido</option>
          </select-input>

          <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full" label="Observaciones" />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Actualizar Animal
          </loading-button>
         <button v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo ml-auto" tabindex="-1" type="button" @click="vacunar">
            Registrar Vacuna
        </button>
        <button v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo ml-auto" tabindex="-1" type="button" @click="pesaje">
            Registrar Peso
        </button>
        <button v-if="$page.props.auth.user.rol !='Cliente' && animal.sexo === 'hembra'" class="btn-indigo ml-auto" tabindex="-1" type="button" @click="eventoReproductivo">
            Registrar Evento Reproductivo
        </button>
        <button v-if="$page.props.auth.user.rol !='Cliente' && animal.sexo === 'hembra'" class="btn-indigo ml-auto" tabindex="-1" type="button" @click="gestacion">
            Registrar Gestación
        </button>
        </div>
        
      </form>
       
        
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Edit Animal' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    animal: Object,
    especies: Array,
    razas: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        codigo: this.animal.codigo ?? null,
        nombre: this.animal.nombre ?? null,
        arete: this.animal.arete ?? null,
        especie_id: this.animal.especie_id ?? null,
        raza_id: this.animal.raza_id ?? null,
        sexo: this.animal.sexo ?? null,
        fecha_nacimiento: this.animal.fecha_nacimiento ?? null,
        peso: this.animal.peso ?? null,
        color: this.animal.color ?? null,
        estado_reproductivo: this.animal.estado_reproductivo ?? null,
        estado: this.animal.estado ?? 'Activo',
        observaciones: this.animal.observaciones ?? null,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('animales.update', this.animal.id))
    },
    vacunar() {
        this.$inertia.get(this.route('animales.vacunas', this.animal.id))
    },
    pesaje() {
        this.$inertia.get(this.route('animales.pesos', this.animal.id))
    },
    eventoReproductivo() {
        this.$inertia.get(this.route('animales.eventos_reproductivos', this.animal.id))
    },
    gestacion() {
        this.$inertia.get(this.route('animales.gestaciones', this.animal.id))
    },
  },
}
</script>